import { Link, Navigate } from "react-router-dom";
import { ChevronRight, Mic, Network, Wallet } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { AppHeader } from "@/components/layout/AppHeader";
import { NamtechFooter } from "@/components/poc/NamtechFooter";

const Tile = ({ to, testid, icon: Icon, title, text, primary }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`group relative block rounded-2xl p-6 min-h-[168px] overflow-hidden transition-transform active:scale-[0.98] ${primary ? "bg-[#0b2a47] text-white" : "c-card"}`}
  >
    <div className="absolute left-0 top-6 bottom-6 w-1 rounded-r bg-[#bc9538]" />
    <Icon className={`w-8 h-8 ${primary ? "text-[#bc9538]" : "c-accent"}`} strokeWidth={1.6} />
    <div className="mt-8 flex items-end justify-between gap-3">
      <div>
        <h2 className="font-heading text-2xl font-extrabold tracking-tight">{title}</h2>
        <p className={`text-sm mt-1 ${primary ? "text-white/70" : "c-text-2"}`}>{text}</p>
      </div>
      <ChevronRight className="w-6 h-6 opacity-60 transition-transform group-hover:translate-x-1" />
    </div>
  </Link>
);

export default function LauncherPage() {
  const { user, isOwner } = useAuth();
  if (!isOwner) return <Navigate to="/conecta" replace />;
  return (
    <div data-testid="launcher-page" className="min-h-screen max-w-md mx-auto flex flex-col">
      <AppHeader eyebrow="Bienvenido" title={user.name} home={false} showLogout titleTestid="header-user-name" />
      <main className="flex-1 px-4 pt-6 space-y-4">
        <Tile to="/inversiones" testid="launcher-inversiones-btn" icon={Wallet} title="Inversiones" text="Inversiones y préstamos personales" primary />
        <Tile to="/conecta" testid="launcher-conecta-btn" icon={Network} title="CONECTA" text="Red, negocios y comisiones" />
        <Link to="/conecta/grabar?auto=1" data-testid="launcher-grabar-btn" className="flex items-center justify-center gap-2 py-4 rounded-2xl bg-[#dc2626] text-white font-heading font-bold text-lg active:scale-[0.98] transition-transform">
          <Mic className="w-6 h-6" /> Grabar nota
        </Link>
      </main>
      <div className="px-4"><NamtechFooter /></div>
    </div>
  );
}
